import { render } from "./A50Ink.vue?vue&type=template&id=1db17400&scoped=true"
import script from "./A50Ink.vue?vue&type=script&lang=js"
export * from "./A50Ink.vue?vue&type=script&lang=js"

import "./A50Ink.vue?vue&type=style&index=0&id=1db17400&lang=scss&scoped=true"

import exportComponent from "/Users/mateomateus/Documents/Rabinovici/hp-blueprint-presentation/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1db17400"]])

export default __exports__